import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, TeamGoal } from "@/types";

export function useGetTeamGoal(month?: number, year?: number) {
  return useQuery({
    queryKey: ["team-goal", month, year],
    enabled: month !== undefined && year !== undefined,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (month !== undefined) params.set("month", month.toString());
      if (year !== undefined) params.set("year", year.toString());

      const res = await guacHttpClient.get<
        TeamGoal | null,
        HttpResponse<TeamGoal | null>
      >(`team-goals?${params.toString()}`);
      return res.data;
    },
  });
}
